import { createAction } from '@reduxjs/toolkit'

import actionTypes from './actionTypes'

export const setSelectedNavbarItem = createAction(
  actionTypes.SET_SELECTED_NAVBAR_ITEM
)
